// src/services/salesService.jsx
import axiosInstance from './axiosConfig';

const salesService = {

  // ─── Sales ───────────────────────────────────────────────
  getAllSales: async () => {
    const response = await axiosInstance.get(`/sales/sales-invoice?page=1&limit=10000`);
    return response.data.data ?? response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/sales/${id}`);
    return response.data.data ?? response.data;
  },

  create: async (payload) => {
    // Uses the user/create endpoint which accepts the new payload structure
    const response = await axiosInstance.post('/sales/user/create', payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/sales/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/sales/delete/${id}`);
    return response.data;
  },

  getInvoiceNumber: async () => {
    const response = await axiosInstance.get('/sales/invoice-number');
    return response.data.data ?? response.data;
  },

  // ─── Inventory / Stock ───────────────────────────────────
  getActiveInventories: async () => {
    const response = await axiosInstance.get('/inventories/active');
    return response.data.data ?? response.data;
  },

  // Returns nested structure: stockItem.product.name, stockItem.product.category, etc.
  getStocksByInventory: async (inventoryId) => {
    const response = await axiosInstance.get(`/stocks/by-inventory/${inventoryId}`);
    return response.data.data ?? response.data;
  },

  // ─── Categories ──────────────────────────────────────────
  getActiveCategories: async () => {
    const response = await axiosInstance.get('/categories/active');
    return response.data.data ?? response.data;
  },

  // ─── Routes ──────────────────────────────────────────────
  getAvailableRoutes: async () => {
    const response = await axiosInstance.get('/routes/available');
    return response.data.data ?? response.data;
  },

  // ─── Customers ───────────────────────────────────────────
  // For Sales table filters — fetches all customers
  getAllCustomers: async () => {
    const response = await axiosInstance.get('/customers?page=1&limit=10000');
    return response.data.data ?? response.data;
  },

  // For Create Sale modal — fetches customers scoped to a route
  getCustomersByRoute: async (routeId) => {
    const response = await axiosInstance.get(`/customers/routes/drop/${routeId}`);
    return response.data.data ?? response.data;
  },

  // ─── Employees ───────────────────────────────────────────
  getEmployees: async () => {
    const response = await axiosInstance.get('/employees');
    return response.data.data ?? response.data;
  },

};

export default salesService;